'use strict';

module.exports = Object.freeze({
  email_media: 'Email',
  fax_media: 'Fax',
  postal_mail_media: 'Postal Mail',
  sms_media: 'Text Message',
  voice_media: 'Voice',
  telegram: 'Telegram',
  linkedin: 'LinkedIn',
  signal: 'Signal',
  twitter: 'Twitter',
  google: 'Google Apps',
  whatsapp: 'Whatsapp',
  instagram: 'Instagram',
  facebook: 'Facebook',
});
